// deps
import React, { useCallback, useMemo } from "react";
import cx from "classnames";

// styles
import styles from "./Slot.scss";

//interface
import { IDeliverySlot } from "@swiggy-private/cart-types";

//helpers
import { convertToDisplaySlot } from "../utils";

//test-ids
import { SLOT_TEST_IDS } from "@swiggy-private/cart-test-ids";

interface ISlot {
    slot: IDeliverySlot;
    onSlotSelect: Function;
    setSelectedSlot: (selectedSlot: string) => void;
}

export default function Slot({ slot, onSlotSelect, setSelectedSlot }: ISlot): React.ReactElement {
    const displaySlot = convertToDisplaySlot(slot.slot_start_time.seconds, slot.slot_end_time.seconds);
    const className = useMemo(
        () =>
            cx(styles.slot, {
                [styles.slotSelected]: slot.selected,
                [styles.slotAvailable]: !slot.selected && slot.available,
                [styles.slotDisabled]: !slot.available,
            }),
        [slot.available, slot.selected],
    );

    const enableClick = !slot.selected && slot.available;

    const onSlotCLick = useCallback(() => {
        onSlotSelect(slot.slot_id);
        setSelectedSlot(displaySlot);
    }, [displaySlot, onSlotSelect, setSelectedSlot, slot.slot_id]);

    if (enableClick) {
        return (
            <button data-testid={SLOT_TEST_IDS.BUTTON} className={className} onClick={onSlotCLick}>
                {displaySlot}
            </button>
        );
    }

    return (
        <button data-testid={SLOT_TEST_IDS.BUTTON} className={className}>
            {displaySlot}
        </button>
    );
}
